export const RouteUrl = {
  login: '',
  logout: '',
  home: '/home',
  signup: '/signup',
  addUser: '/user',
  changePassword: '/change-password',
  forgetPassword: '/forget-password',
  role: '/role',
  assingRole: '/role/assign',
  inclusionType: '/product/inclusion',
  documentType: '/product/document',
  collectionMethod: '/product/collection',
  addProduct: '/product/product-form',
  productDocument: '/product/product-document',
  productEligibility: '/product/product-eligibility',
  addGroupPolicyProduct: '/product/group-policy-product',
  ppoList: 'product/ppo-list',
  newCase: 'product/newCasePreApproval',
  claimAmountEntry: '',
  enrol: '/enrol/grouppolicy',
  enrolDependent: '/enrol/dependent',
  groupPolicyUser: 'group-policy-user',
  claimDataEntry: '/claim-processing/data-entry',
  enrolleClass: '/enroll-class',
  GroupPolicyClusterProduct: '/product/group-policy-cluster-product',
  claimBenefit: '/claim-benefit',
  groupPolicyProductDetail: '/group-policy/product-detail',
  groupPolicyClusterProductBenefit: '/group-policy/group-policy-cluster-product-benefit',
  dataEntryQueue: '/product/data-entry-queue',
  claimDocumentEntry: '/claim-processing/document-entry',
  medicalAdvisorEntryQueue: '/claim-processing/medical-advisor-entry-queue',
  onlineGroupClaimSubmission: '/product/validating-enrollee',
  preApprovedBillEntry: '/product/pre-approved-bill-entry',
  policyInvestigation: '/investigation-queue/policy-investigation',
  investigationEntryQueue: '/investigation-queue/investigation-entry-queue',
  nigoDocumentUpload: '/product/nigo-document-upload',
  claimHistory: '/reporting/claim-history',
  claimSubmissionGl: '/claim-submission-gl',
  ebDashboard: '/reporting/employee-dashboard',
  ebDashboardLogin: '/eb-dashboard-login',
  claimSubmission: '/claim-submission',
};
